/*
 * vendor-logo-fallback.js
 * Logo-urile de vendor din cardul de produs (.badges-logo img) au src cu extensie
 * .png (conventia temei). Pentru vendorii al caror logo e in alt format (svg/jpg/webp,
 * ex. Delphin), .png da 404. Acest script incearca automat extensiile alternative
 * si, daca niciuna nu exista, ascunde elementul (fara icon rupt).
 *
 * Ordine: .png (deja incercat prin src) -> .svg -> .jpg -> .jpeg -> .webp -> hide.
 * Fara request-uri extra pentru logo-urile .png care se incarca corect.
 *
 * Folosim un listener de 'error' in faza de CAPTURE pe document: evenimentul 'error'
 * pe <img> nu face bubble, dar se prinde in capture. Astfel un singur handler acopera
 * toate logo-urile, inclusiv cardurile adaugate dinamic (infinite scroll), fara init
 * per-element.
 */
(function () {
  "use strict";

  var EXTS = ["svg", "jpg", "jpeg", "webp"];

  function baseOf(img) {
    var base = img.getAttribute("data-logo-base");
    if (base) return base;
    var src = img.getAttribute("src") || "";
    base = src.split("?")[0].replace(/\.[a-z0-9]+$/i, "");
    img.setAttribute("data-logo-base", base);
    return base;
  }

  function handleFail(img) {
    if (!img || img.tagName !== "IMG") return;
    if (!img.closest || !img.closest(".badges-logo")) return;

    var base = baseOf(img);
    if (!base) return;

    var tryIdx = parseInt(img.getAttribute("data-logo-try") || "0", 10);
    if (tryIdx >= EXTS.length) {
      var box = img.closest(".badges-logo");
      if (box) box.style.display = "none";
      return;
    }
    img.setAttribute("data-logo-try", tryIdx + 1);
    img.src = base + "." + EXTS[tryIdx];
  }

  // Viitoare (inclusiv carduri din infinite scroll): 'error' se prinde in capture.
  document.addEventListener(
    "error",
    function (e) {
      var img = e.target;
      if (img && img.tagName === "IMG" && img.closest && img.closest(".badges-logo")) {
        handleFail(img);
      }
    },
    true
  );

  // Logo-uri care au esuat deja inainte ca listenerul sa fie atasat.
  function scanExisting() {
    var logos = document.querySelectorAll(".badges-logo img");
    Array.prototype.forEach.call(logos, function (img) {
      if (img.complete && img.naturalWidth === 0 && !img.getAttribute("data-logo-try")) {
        handleFail(img);
      }
    });
  }

  if (document.readyState !== "loading") {
    scanExisting();
  } else {
    document.addEventListener("DOMContentLoaded", scanExisting);
  }
})();
